import React, { useState } from "react";
import "./Career.css";

import {
  FaWhatsapp,
  FaHandshake,
  FaIdCard,
  FaRoute,
  FaHeadset,
} from "react-icons/fa";


/* =========================================
   CAREER OPPORTUNITIES
========================================= */

const careerOpportunities = [

  {
    title: "Driver Partner",

    icon: <FaIdCard />,

    description:
      "Join Sai Shirdi Cabs as a professional driver partner and serve pilgrims and travelers visiting Shirdi with safe, comfortable and reliable transportation.",

    points: [
      "Regular Shirdi Cab Trips",
      "Sai Baba Darshan Travel",
      "One Way & Round Trip Bookings",
      "Flexible Working Opportunities",
    ],
  },


  {
    title: "Travel Partner",

    icon: <FaHandshake />,

    description:
      "Partner with Sai Shirdi Cabs and help travelers arrange reliable cab services for Shirdi visits, pilgrimage trips and local sightseeing.",

    points: [
      "Pilgrimage Travel Bookings",
      "Local & Outstation Trips",
      "Flexible Partnership Opportunities",
      "Dedicated Support",
    ],
  },


  {
    title: "Travel Coordinator",

    icon: <FaRoute />,

    description:
      "Help customers plan their Shirdi journeys, coordinate cab bookings and ensure a smooth travel experience from pickup to destination.",

    points: [
      "Cab Booking Coordination",
      "Customer Travel Assistance",
      "Pickup & Drop Coordination",
      "Booking Management",
    ],
  },


  {
    title: "Customer Support Executive",

    icon: <FaHeadset />,

    description:
      "Assist pilgrims and travelers with cab enquiries, bookings, pickup details and travel-related queries while providing excellent customer service.",

    points: [
      "Customer Assistance",
      "Cab Booking Support",
      "Driver Coordination",
      "Travel Enquiry Management",
    ],
  },

];


/* =========================================
   CAREER COMPONENT
========================================= */

const Career = () => {

  const [formData, setFormData] = useState({

    name: "",
    phone: "",
    email: "",
    city: "",
    position: "",
    experience: "",
    message: "",

  });


  /* =========================================
     HANDLE FORM CHANGE
  ========================================= */

  const handleChange = (e) => {

    setFormData({

      ...formData,

      [e.target.name]: e.target.value,

    });

  };


  /* =========================================
     WHATSAPP SUBMIT
  ========================================= */

  const handleSubmit = (e) => {

    e.preventDefault();


    const message = `*Sai Shirdi Cabs Career Application*

Name : ${formData.name}
Phone : ${formData.phone}
Email : ${formData.email}
City : ${formData.city}
Position : ${formData.position}
Experience : ${formData.experience}

Message :
${formData.message}`;


    /* 
       WhatsApp submission number:
       +91 77768 14559
    */

    window.open(
      `https://wa.me/917776814559?text=${encodeURIComponent(message)}`,
      "_blank"
    );

  };


  return (

    <>

      {/* =========================================
          PAGE BANNER
      ========================================= */}

      <section className="page-banner">

        <div className="page-banner-container">

          <h2>
            Career
          </h2>

        </div>

      </section>



      {/* =========================================
          CAREER SECTION
      ========================================= */}

      <section className="career-section">

        <div className="container">

          <div className="row">


            {/* =====================================
                RIGHT / INFORMATION SECTION
            ===================================== */}

            <div className="col-lg-5">

              <div className="career-info">


                <h2>
                  Career Opportunities
                </h2>


                <p>
                  Join Sai Shirdi Cabs and become part of a trusted
                  travel service dedicated to providing safe,
                  comfortable and reliable transportation for
                  pilgrims and travelers visiting Shirdi.
                </p>


                {/* =================================
                    CAREER CARDS
                ================================= */}

                {careerOpportunities.map((job, index) => (

                  <div
                    className="career-card"
                    key={index}
                  >


                    <div className="career-icon">

                      {job.icon}

                    </div>


                    <div className="career-content">

                      <h4>
                        {job.title}
                      </h4>


                      <p>
                        {job.description}
                      </p>


                      <ul>

                        {job.points.map((point, i) => (

                          <li key={i}>

                            <i className="fas fa-check-circle"></i>

                            {point}

                          </li>

                        ))}

                      </ul>

                    </div>


                  </div>

                ))}


              </div>

            </div>



            {/* =====================================
                APPLICATION SECTION
            ===================================== */}

            <div className="col-lg-7">


              {/* =================================
                  APPLICATION FORM
              ================================= */}

              <div className="career-form">


                <h2>
                  Apply Now
                </h2>


                <p>
                  Interested in working with Sai Shirdi Cabs?
                  Complete the application form below and send
                  your details directly to our team on WhatsApp.
                </p>


                <form onSubmit={handleSubmit}>


                  <div className="row">


                    {/* FULL NAME */}

                    <div className="col-md-6">

                      <input
                        type="text"
                        placeholder="Full Name"
                        name="name"
                        value={formData.name}
                        required
                        onChange={handleChange}
                      />

                    </div>


                    {/* MOBILE */}

                    <div className="col-md-6">

                      <input
                        type="tel"
                        placeholder="Mobile Number"
                        name="phone"
                        value={formData.phone}
                        required
                        onChange={handleChange}
                      />

                    </div>


                    {/* EMAIL */}

                    <div className="col-md-6">

                      <input
                        type="email"
                        placeholder="Email Address"
                        name="email"
                        value={formData.email}
                        required
                        onChange={handleChange}
                      />

                    </div>


                    {/* CITY */}

                    <div className="col-md-6">

                      <input
                        type="text"
                        placeholder="Current City"
                        name="city"
                        value={formData.city}
                        required
                        onChange={handleChange}
                      />

                    </div>


                    {/* POSITION */}

                    <div className="col-md-6">

                      <select
                        name="position"
                        value={formData.position}
                        required
                        onChange={handleChange}
                      >

                        <option value="">
                          Select Position
                        </option>

                        <option>
                          Driver Partner
                        </option>

                        <option>
                          Travel Partner
                        </option>

                        <option>
                          Travel Coordinator
                        </option>

                        <option>
                          Customer Support Executive
                        </option>

                      </select>

                    </div>


                    {/* EXPERIENCE */}

                    <div className="col-md-6">

                      <select
                        name="experience"
                        value={formData.experience}
                        required
                        onChange={handleChange}
                      >

                        <option value="">
                          Select Experience
                        </option>

                        <option>
                          Fresher
                        </option>

                        <option>
                          1 - 2 Years
                        </option>

                        <option>
                          3 - 5 Years
                        </option>

                        <option>
                          5+ Years
                        </option>

                      </select>

                    </div>


                    {/* MESSAGE */}

                    <div className="col-12">

                      <textarea
                        rows="5"
                        name="message"
                        value={formData.message}
                        placeholder="Tell us about yourself, your driving experience or the position you are interested in..."
                        onChange={handleChange}
                      ></textarea>

                    </div>


                    {/* SUBMIT BUTTON */}

                    <div className="col-12">

                      <button
                        type="submit"
                        className="career-btn"
                      >

                        <FaWhatsapp />

                        Submit Application

                      </button>

                    </div>


                  </div>


                </form>


              </div>



              {/* =================================
                  CONTACT HR / OFFICE
              ================================= */}

              <div className="career-contact">


                <h3>
                  Contact Sai Shirdi Cabs
                </h3>


                <p className="career-contact-text">

                  Have questions about career opportunities
                  with Sai Shirdi Cabs? Contact our team for
                  more information about available positions
                  and partnership opportunities.

                </p>



                {/* MOBILE */}

                <div className="career-contact-item">


                  <div className="career-contact-icon">

                    <i className="fas fa-phone-alt"></i>

                  </div>


                  <div>

                    <h5>
                      Mobile Numbers
                    </h5>


                    <p>

                      <a href="tel:+917776814559">
                        +91 77768 14559
                      </a>

                      <br />

                      <a href="tel:+919579032227">
                        +91 95790 32227
                      </a>

                    </p>

                  </div>


                </div>



                {/* WHATSAPP */}

                <div className="career-contact-item">


                  <div className="career-contact-icon">

                    <FaWhatsapp />

                  </div>


                  <div>

                    <h5>
                      WhatsApp Applications
                    </h5>


                    <p>

                      <a
                        href="https://wa.me/917776814559"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Chat With Us on WhatsApp
                      </a>

                    </p>

                  </div>


                </div>



                {/* ADDRESS */}

                <div className="career-contact-item">


                  <div className="career-contact-icon">

                    <i className="fas fa-map-marker-alt"></i>

                  </div>


                  <div>

                    <h5>
                      Office Address
                    </h5>


                    <p>

                      <strong>
                        Sai Shirdi Cabs
                      </strong>

                      <br />

                      Sai Mandir Lane,
                      Near Hotel Sai Kanhaiya,

                      <br />

                      Shirdi, Tel - Rahata,

                      <br />

                      Dist. Ahilyanagar,

                      <br />

                      Maharashtra, India - 423109

                    </p>

                  </div>


                </div>


              </div>


            </div>


          </div>

        </div>

      </section>

    </>

  );

};


export default Career;
